import { IdeaApiMethodEnum, IIdeaApiRequest } from "@ideatech/ngx-ideatech";
import { ISignInRequest } from "../interfaces/api-requests/sign-in-request.interface";
import { ISignUpRequest } from "../interfaces/api-requests/sign-up-request.interface";
import { IRefreshTokenRequest } from "../interfaces/api-requests/refresh-token-request.interface";
import { IPostProjectRequest } from "../interfaces/api-requests/post-project-request.interface";
import { IPostProjectButtonPanelRequest } from "../interfaces/api-requests/post-project-button-panel-request.interface";
import { IPostCalculateItemsPriceRequest } from "../interfaces/api-requests/post-calculate-items-price-request.interface";
import { IPutProjectButtonPanelRequest } from "../interfaces/api-requests/put-project-button-panel-request.interface";
import { IPostCloneProjectRequest } from "../interfaces/api-requests/post-clone-project-request.interface";
import { IPostGetButtonPanelStandardRequest } from "../interfaces/api-requests/post-get-button-panel-standard-request.interface";
import { IGetItemsByIdCategoryRequest } from "../interfaces/api-requests/get-items-by-id-category-request.interface";
import { IPostGetButtonPanelDefaultValuesRequest } from "../interfaces/api-requests/post-get-button-panel-default-values-request.interface";
import { ISaveProjectSparePartsRequest } from "../interfaces/api-requests/save-project-spare-part-request.interface";
import { IPutProjectSparePartRequest } from "../interfaces/api-requests/put-project-spare-part-request.interface";
import { ISaveProjectButtonPanelItemRequest } from "../interfaces/api-requests/save-project-button-panel-item-request.interface";
import { DetailsLevel } from "../enums/details-level.enum";
import { IInitializeItemsTableFiltersByIdCategoryRequest } from "../interfaces/api-requests/initialize-items-table-filters-by-id-category-request.interface";
import { IGetItemByIdByCategoryRequest } from "../interfaces/api-requests/get-item-by-id-by-category-request.interface";
import { IGetFiltersBySubfamilyRequest } from "../interfaces/api-requests/get-filters-by-subfamily-request.interface";
import { IGetSubfamilyByFamilyAndFilterRequest } from "../interfaces/api-requests/get-subfamily-by-family-and-filter-request.interface";
import { IGetItemByCategoryRequest } from "../interfaces/api-requests/get-item-by-category-request.interface";

export class ApiHolder {

    static account = {
        controllerName: "account",
        get(): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/get`,
                method: IdeaApiMethodEnum.GET
            }
        },
        signin(body: ISignInRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/signin`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        signup(body: ISignUpRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/signup`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        refreshToken(body?: IRefreshTokenRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/refreshtoken`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        getCustomersLookup(): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/customerlookup`,
                method: IdeaApiMethodEnum.GET
            }
        }
    }

    static project = {
        controllerName: "project",
        getAll(): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}`,
                method: IdeaApiMethodEnum.GET
            }
        },
        getAllTeams(): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/getTeams`,
                method: IdeaApiMethodEnum.GET
            }
        },
        getById(id: number, details: DetailsLevel): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/${id}`,
                method: IdeaApiMethodEnum.GET,
                parameters: { details }
            }
        },
        post(body: IPostProjectRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        put(body: IPostProjectRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}`,
                method: IdeaApiMethodEnum.PUT,
                body
            }
        },
        delete(id: number): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/${id}`,
                method: IdeaApiMethodEnum.DELETE
            }
        },
        confirm(id: number): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/${id}/confirm`,
                method: IdeaApiMethodEnum.POST
            }
        },
        clone(body: IPostCloneProjectRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/clone`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        }
    }

    static projectButtonPanel = {
        controllerName: "projectbuttonpanel",
        getById(id: number, idProject: number): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/${id}`,
                method: IdeaApiMethodEnum.GET,
                parameters: { idProject: idProject }
            }
        },
        post(body: IPostProjectButtonPanelRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        update(body: IPutProjectButtonPanelRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}`,
                method: IdeaApiMethodEnum.PUT,
                body
            }
        },
        delete(id: number, idProject: number): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/${id}`,
                method: IdeaApiMethodEnum.DELETE,
                parameters: { idProject: idProject }
            }
        },
        calculatePlate(body: IPostProjectButtonPanelRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/calculatePlate`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        calculateItemsPrice(body: IPostCalculateItemsPriceRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/calculateItemsPrice`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        getConfigurationImage(id: number, idProject: number): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/${id}/configurationImage`,
                method: IdeaApiMethodEnum.GET,
                parameters: { idProject: idProject }
            }
        },
        saveReportImage(body: FormData): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/saveReportImage`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        saveButtonImage(body: FormData): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/saveButtonImage`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        uploadLogoImage(body: FormData): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/uploadLogoImage`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        }
    }

    static formData = {
        controllerName: "formdata",
        getAllProjectStatus(): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/getallprojectstatus`,
                method: IdeaApiMethodEnum.GET
            }
        },
        getAllButtonPanelLookupList(): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/getallbuttonpanellookuplist`,
                method: IdeaApiMethodEnum.GET
            }
        },
        getButtonPanelStandardBySettings(body: IPostGetButtonPanelStandardRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/getbuttonpanelstandardbysettings`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        getButtonPanelDefaultValuesBySettings(body: IPostGetButtonPanelDefaultValuesRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/getbuttonpaneldefaultvaluesbysettings`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        }
    }

    static itemCategory = {
        controllerName: "itemcategory",
        get(): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}`,
                method: IdeaApiMethodEnum.GET
            }
        }
    }

    static item = {
        controllerName: "item",
        searchByIdCategory(body: IGetItemsByIdCategoryRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/searchByIdCategory`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        initializeTableFiltersByIdCategory(body: IInitializeItemsTableFiltersByIdCategoryRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/initializeTableFiltersByIdCategory`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        getButtonItemInfoById(body: IGetItemByIdByCategoryRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/getButtonItemInfoById`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        getItemByCategory(body: IGetItemByCategoryRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/getItemByCategory`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        getSubfamilyInfoById(body: IGetFiltersBySubfamilyRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/getSubfamilyInfoById`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        getAllEasyliftFeature(): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/getAllEasyliftFeature`,
                method: IdeaApiMethodEnum.GET
            }
        },
        getSubfamilyByFamilyAndFilter(body: IGetSubfamilyByFamilyAndFilterRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/getSubfamilyByFamilyAndFilter`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        }
    }

    static preSignedUrl = {
        controllerName: "presignedurl",
        get(fileName: string): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}`,
                method: IdeaApiMethodEnum.GET,
                parameters: { fileName }
            }
        }
    }

    static projectSparePart = {
        controllerName: "projectsparepart",
        save(body: ISaveProjectSparePartsRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/save`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        },
        put(body: IPutProjectSparePartRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}`,
                method: IdeaApiMethodEnum.PUT,
                body
            }
        },
        delete(idProjectSparePart: number, idProject: number): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/${idProjectSparePart}`,
                method: IdeaApiMethodEnum.DELETE,
                parameters: { idProject }
            }
        }
    }

    static projectButtonPanelItem = {
        controllerName: "projectbuttonpanelitem",
        save(body: ISaveProjectButtonPanelItemRequest): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/save`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        }
    }
    static report = {
        controllerName: "report",
        GenerateProjectReportPdf(body: FormData): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/generateProjectReportPdf`,
                method: IdeaApiMethodEnum.POST,
                body
            }
        }
    }

    static customerLogo = {
        controllerName: "customerlogo",
        getByCustomer(idCustomer: number): IIdeaApiRequest {
            return {
                relativeUrl: `${this.controllerName}/byCustomer`,
                method: IdeaApiMethodEnum.GET,
                parameters: { idCustomer }
            }
        }
    }
}
